/* AISEN PDP — galeria simples (troca de imagem principal). Vanilla, sem deps. */
(function () {
  'use strict';
  function init(root) {
    var gal = (root || document).querySelector('[data-aisen-gallery]');
    if (!gal || gal._init) return;
    gal._init = true;
    var main = gal.querySelector('#aisen-pdp-main');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-thumb]'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        var full = t.getAttribute('data-full');
        if (full) { main.removeAttribute('srcset'); main.src = full; }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  // Theme Editor: re-init quando a section recarrega
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
